<!--<div class="bold medium">{{'ADMIN_LTI.TABS.OBJECTIVES' | translate}}</div>-->
<div class="hint background3">
  <i class="fa fa-info-circle"></i>
  &nbsp;{{ text }}
</div>
<table class="table">
  <thead>
    <tr>
      <th></th>
      <th class="background3" *ngFor="let year of getYears()">{{ year }}</th>
      <th class="background3"></th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let item of objList">
      <tr>
        <td class="background3">{{ item.Goal.Name }}</td>
        <td *ngFor="let year of getYears()" class="giallo">
          {{ getObjectiveValue(item, year) }}
        </td>
        <th class="background3">
          <i
            class="fa fa-caret-down pointer"
            [ngClass]="{
              'fa-caret-down': !item.showDetail,
              'fa-caret-up': item.showDetail
            }"
            (click)="item.showDetail = !item.showDetail"
          ></i>
        </th>
      </tr>
      <tr *ngIf="item.showDetail">
        <td [attr.colspan]="getYears().length + 6">{{ item.Name }}</td>
      </tr>
    </ng-container>
  </tbody>
</table>
